import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ArcStack from '@src/core/ui/arc-stack';
import ArcText from '@src/core/ui/arc-text';
import ArcIconButton from '@src/core/ui/arc-icon-button';
import { ArcDialogProps } from './types';

const ArcDialog: React.FC<ArcDialogProps> = (props) => {
  const { children, contextSX, title, headerActions, titleDivider, headerIconSize, onClose, ...rest } = props;

  const handleClose = (
    event = {},
    reason: 'backdropClick' | 'escapeKeyDown',
  ) => {
    onClose && onClose(event, reason);
  };


  return (
    <Dialog 
      onClose={handleClose} 
      {...rest}>
      <DialogContent sx={{ px: 3, py: 2, minWidth: 450, ...contextSX }}>
        <ArcStack
          direction='row' 
          alignItems='center'
          sx={titleDivider ? {
            mx: -3,
            px: 3,
            py: 1.5,
            mb: 2,
            borderBottom: (theme) => `1px solid ${alpha(theme.palette.common.white, 0.12)}`,
          } : { mt: 1.5, mb: 2.5 }}>
          {typeof title === 'string' ? <ArcText.h5> {title} </ArcText.h5> : title}
          <ArcStack direction='row' alignItems='center' spacing={1} sx={{ ml: 'auto' }}>
            {headerActions}
            <ArcIconButton 
              size='small' 
              sx={headerIconSize
                ? { p: 0, '& svg': { fontSize: headerIconSize } }
                : { width: 50, height: 50 }}
              onClick={(e) => handleClose(e, 'backdropClick')}> 
              <CloseIcon /> 
            </ArcIconButton>
          </ArcStack>
        </ArcStack>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default ArcDialog;